export const SET_ALERTS_PAGE_NUMBER = 'alerts/SET_ALERTS_PAGE_NUMBER'
export const SET_ALERTS_LIMIT_PAGE = 'alerts/SET_ALERTS_LIMIT_PAGE'
export const SET_ALERTS_FILTER_DATA = 'alerts/SET_ALERTS_FILTER_DATA'
export const SET_ALERT_RULE_CONDITIONS = 'alerts/SET_ALERT_RULE_CONDITIONS'
export const SET_ALERT_RULE_STATUSES = 'alerts/SET_ALERT_RULE_STATUSES'
export const SET_ALERT_RULE_STORES = 'alerts/SET_ALERT_RULE_STORES'
export const SET_ALERT_RULE_LIMIT_PAGE = 'alerts/SET_ALERT_RULE_LIMIT_PAGE'
export const SET_ALERT_RULE_PAGE_NUMBER = 'alerts/SET_ALERT_RULE_PAGE_NUMBER'

export const setAlertsPageNumber = payload => ({
  type: SET_ALERTS_PAGE_NUMBER,
  payload
})

export const setAlertsLimitPage = payload => ({
  type: SET_ALERTS_LIMIT_PAGE,
  payload
})

export const setAlertsFilterData = payload => ({
  type: SET_ALERTS_FILTER_DATA,
  payload
})

export const setAlertRuleCondition = payload => ({
  type: SET_ALERT_RULE_CONDITIONS,
  payload
})

export const setAlertRuleStatus = payload => ({
  type: SET_ALERT_RULE_STATUSES,
  payload
})

export const setAlertRuleStore = payload => ({
  type: SET_ALERT_RULE_STORES,
  payload
})

export const setAlertRuleLimitPage = payload => ({
  type: SET_ALERT_RULE_LIMIT_PAGE,
  payload
})

export const setAlertRulePageNumber = payload => ({
  type: SET_ALERT_RULE_PAGE_NUMBER,
  payload
})
